import { defaultsOf, param, personalUiParam, primary, uiParam, type ConfigOf } from './registry';

// CFG-UC-1: параметры интерфейса — публичные, действуют сразу. Интерфейс работает с этими
// умолчаниями, пока конфигурация не получена с сервера, и в Storybook. Личные (personalUiParam)
// пользователь задаёт себе в профиле (PREF-UC-3; почему именно эти — ADR-013).

export const UI_PARAMS = {
  realtime: {
    reconnectDelaysMs: param.intList(
      [1000, 2000, 5000, 10_000, 30_000],
      { min: 100, max: 600_000, minItems: 1, maxItems: 10 },
      uiParam('Паузы между попытками переподключения (SYS-UC-13.CC-1); дальше повторяется последняя', 'Delays between reconnect attempts; then the last one repeats'),
    ),
    problemAfterMs: param.int(3000, 0, 60_000, uiParam('Через сколько без связи показать панель «Нет связи с сервером»', 'Show the "No connection" bar after this long offline')),
    stableAfterMs: param.int(1000, 0, 60_000, uiParam('Соединение считается установленным, если продержалось столько', 'A connection counts as established after lasting this long')),
  },
  search: {
    delayMs: param.int(300, 0, 5000, uiParam('Пауза после ввода перед поиском в автокомплите', 'Pause after typing before an autocomplete search')),
  },
  combobox: {
    loadMoreEdgePx: param.int(32, 0, 1000, uiParam('За сколько до конца списка автокомплита подгружать следующую страницу', 'Load the next autocomplete page this close to the end of the list')),
  },
  lists: {
    pageSize: param.int(60, 10, 500, primary(personalUiParam('Сколько постов, медиа и записей показывать на странице', 'Posts, media and entries per page'))),
  },
  references: {
    pageSize: param.int(20, 5, 200, uiParam('Размер страницы выбора ссылки на запись или пост (ENT-UC-8)', 'Page size when picking a linked entry or post')),
  },
  timeZones: {
    pageSize: param.int(50, 10, 500, uiParam('Сколько часовых поясов в странице автокомплита (WS-RULE-2)', 'Time zones per autocomplete page')),
  },
  users: {
    pageSize: param.int(20, 5, 200, uiParam('Сколько пользователей в странице автокомплита выбора пользователя (IAM-UC-6.CC-2)', 'Users per page when picking a user')),
  },
  posts: {
    card: {
      visibleTags: param.int(6, 0, 60, personalUiParam('Сколько тегов видно в карточке поста; остальные — «+N»', 'Tags visible on a post card; the rest are "+N"')),
    },
    dates: {
      sameMomentSeconds: param.int(
        60,
        0,
        3600,
        uiParam('Изменение раньше этого после создания не показывается отдельной датой (POST-UC-6.CC-1)', 'An edit sooner than this after creation is not shown as a separate date'),
      ),
    },
  },
  entities: {
    table: {
      maxFieldColumns: param.int(3, 0, 20, personalUiParam('Сколько полей записи показывать столбцами в таблице справочника', 'Entry fields shown as columns in a catalog table')),
    },
  },
  calendar: {
    monthCellLimit: param.int(
      3,
      1,
      20,
      personalUiParam('Сколько публикаций видно в ячейке месяца календаря; остальные — «ещё N»', 'Publications visible in a calendar month cell; the rest are "N more"'),
    ),
  },
  publishing: {
    onTimeMinutes: param.int(5, 0, 1440, uiParam('Опоздание меньше этого показывается в «К публикации» как «вовремя» (PUB-UC-1)', 'Lateness under this is shown as "on time" in "Due"')),
  },
  scheduling: {
    defaultExactOffsetHours: param.int(
      24,
      0,
      720,
      personalUiParam('Точное время публикации по умолчанию — через столько от текущего', 'Default exact publication time is this far from now'),
    ),
  },
};

export type UiConfig = ConfigOf<typeof UI_PARAMS>;

export const UI_DEFAULTS: UiConfig = defaultsOf(UI_PARAMS);
